"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const react_select_1 = __importDefault(require("react-select"));
const themes_1 = require("@radix-ui/themes");
const react_icons_1 = require("@radix-ui/react-icons");
const RegionSelector = ({ options, onRegionChange, selectedRegion, }) => {
    const setSearchParams = (0, react_router_dom_1.useSearchParams)()[1];
    const handleChange = (selectedOption) => __awaiter(void 0, void 0, void 0, function* () {
        if (selectedOption) {
            yield fetch(`${window.location.host}?region=${selectedOption.value}`);
            onRegionChange(selectedOption);
            setSearchParams({ region: selectedOption.value });
        }
        else {
            onRegionChange(null);
            setSearchParams({});
        }
    });
    const errorMessage = (0, react_1.useMemo)(() => {
        if ((selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.showMessage) && (selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.unavailableMessage)) {
            return selectedRegion.unavailableMessage;
        }
        if (selectedRegion && !selectedRegion.isActive) {
            return __.trans('login.region-unavailable');
        }
        return '';
    }, [selectedRegion]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "region-selector-container", children: [(0, jsx_runtime_1.jsxs)("label", { htmlFor: "region-select", children: [" ", __.trans('login.login-choose-region')] }), (0, jsx_runtime_1.jsx)(react_select_1.default, { id: "region-select", options: options, onChange: handleChange, "aria-label": __.trans('login.login-choose-region-aria-label'), placeholder: __.trans('login.login-choose-region-placeholder'), isSearchable: false }), errorMessage && ((0, jsx_runtime_1.jsxs)(themes_1.Callout.Root, { className: "callout callout-warning", role: "alert", children: [(0, jsx_runtime_1.jsx)(themes_1.Callout.Icon, { children: (0, jsx_runtime_1.jsx)(react_icons_1.InfoCircledIcon, {}) }), (0, jsx_runtime_1.jsx)(themes_1.Callout.Text, { children: errorMessage })] }))] }));
};
exports.default = RegionSelector;
